<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <app-currency-detail
      [currency]="currency"
      [mode]="mode"
      [defaultLanguage]="defaultLanguage"
      [additionalLanguages]="additionalLanguages"
      [isModal]="true"
      (savedCurrency)="onSavedCurrency($event)"
      (canceledCurrency)="onCanceledCurrency()"
    ></app-currency-detail>
  </div>
</div>
